<template>
    <div class="py-4 container-fluid">
        <div class="row mt-4">
            <div class="col-md-12 col-12">
                <div class="card">

                    <!-- 기간 설정 영역 -->
                    <div class="card-header">
                        <div class="row">
                            <div class="col-md-4 mb-2">
                                <h6><i class="fas fa-tooth onmaum-text-dental"></i> 치과DB 통계</h6>
                            </div>
                            <div class="col-md-8 mb-2">
                                <label class="form-control-label">기간설정</label>
                                <VueDatePicker v-model="this.$store.state.common.period" :format="formatPeriod" range></VueDatePicker>
                            </div>
                        </div>
                    </div>

                    <!-- 컨텐츠 영역 -->
                    <div class="row card-body">
                        <!-- 치과별 건수 -->
                        <div class="col-md-4 mb-2">
                            <div class="card">
                                <div class="p-3 pb-0 card-header">
                                    <div class="d-flex justify-content-between">
                                        <h6 class="mb-2"><i class="fas fa-circle onmaum-text-default"></i> 치과별 등록 건수</h6>
                                    </div>
                                </div>
                                <div class="table-responsive">
                                    <table class="table align-items-center">
                                        <thead>
                                            <tr class="text-center">
                                                <th>치과</th>
                                                <th>건수</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(dental, i) in dentalCount" :key="i">
                                                <td class="">
                                                    <div class="text-center">
                                                        <h6 class="">{{ formatNumber(dental.hospital) }}</h6>
                                                    </div>
                                                </td>
                                                <td class="">
                                                    <div class="text-center">
                                                        <h6 class="">{{ formatNumber(dental.count) }}건</h6>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr style="background: lightgray;">
                                                <td class="">
                                                    <div class="text-center">
                                                        <h6 class="">계</h6>
                                                    </div>
                                                </td>
                                                <td class="">
                                                    <div class="text-center">
                                                        <h6 class="">{{ formatNumber(dentalTotalCount) }}건</h6>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        <!-- 플래너별 건수 및 체결액 -->
                        <div class="col-md-8 mb-2">
                            <div class="card">
                                <div class="p-3 pb-0 card-header">
                                    <div class="d-flex justify-content-between">
                                        <h6 class="mb-2"><i class="fas fa-circle onmaum-text-success"></i> 플래너별 등록 건수/체결액</h6>
                                    </div>
                                </div>
                                <div class="table-responsive">
                                    <table class="table align-items-center">
                                        <thead>
                                            <tr class="text-center">
                                                <th>플래너</th>
                                                <th>총 건수</th>
                                                <th>상주 건수</th>
                                                <th>체결액</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(planner, i) in plannerCount" :key="i">
                                                <td class="">
                                                    <div class="text-center">
                                                        <h6 class="">{{ planner.planner }}</h6>
                                                    </div>
                                                </td>
                                                <td class="">
                                                    <div class="text-center">
                                                        <h6 class="">{{ formatNumber(planner.count) }}건</h6>
                                                    </div>
                                                </td>
                                                <td class="">
                                                    <div class="text-center">
                                                        <h6 class="">{{ formatNumber(planner.reside) }}건</h6>
                                                    </div>
                                                </td>
                                                <td class="">
                                                    <div class="text-center">
                                                        <h6 class="">{{ formatNumber(planner.price) }}원</h6>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr style="background: lightgray;">
                                                <td class="">
                                                    <div class="text-center">
                                                        <h6 class="">계</h6>
                                                    </div>
                                                </td>
                                                <td class="">
                                                    <div class="text-center">
                                                        <h6 class="">{{ formatNumber(plannerTotalCount) }}건</h6>
                                                    </div>
                                                </td>
                                                <td class="">
                                                    <div class="text-center">
                                                        <h6 class="">{{ formatNumber(plannerTotalReside) }}건</h6>
                                                    </div>
                                                </td>
                                                <td class="">
                                                    <div class="text-center">
                                                        <h6 class="">{{ formatNumber(plannerTotalPrice) }}원</h6>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            
        </div>
    </div>
</template>

<script>
export default {
    name: 'StatisticsDental',

    data(){
        return {
            
        }
    },

    methods:{
        initializeDateRange(){
            const startDate = new Date();
            const endDate = new Date();
            startDate.setDate(endDate.getDate() - 7);
            this.$store.state.common.period = [startDate, endDate];
        },

        formatPeriod(){
            const startDay = this.$store.state.common.period[0].getDate();
            const startMonth = this.$store.state.common.period[0].getMonth() + 1;
            const startYear = this.$store.state.common.period[0].getFullYear();

            const newStartDate = `${startYear}/${startMonth}/${startDay}`;

            const endDay = this.$store.state.common.period[1].getDate();
            const endMonth = this.$store.state.common.period[1].getMonth() + 1;
            const endYear = this.$store.state.common.period[1].getFullYear();

            const newEndDate = `${endYear}/${endMonth}/${endDay}`;

            return `${newStartDate}~${newEndDate}`;
        },

        formatNumber(num){
            return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        }
    },

    computed: {
        dentalCount(){
            return this.$store.getters.getStatisticsDentalCount[0];
        },

        dentalTotalCount(){
            return this.$store.getters.getStatisticsDentalCount[1];
        },

        plannerCount(){
            return this.$store.getters.getStatisticsPlannerCount[0];
        },

        plannerTotalCount(){
            return this.$store.getters.getStatisticsPlannerCount[1];
        },

        plannerTotalPrice(){
            return this.$store.getters.getStatisticsPlannerCount[2];
        },

        plannerTotalReside(){
            return this.$store.getters.getStatisticsPlannerCount[3];
        }
    },

    mounted(){
        this.initializeDateRange();
    },

}
</script>

<style>

</style>